import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import { serviceFetchMedicineSuggestions } from "./api"; // Adjust the import path as necessary

const MedicineAutocomplete = ({
  name,
  value,
  onChange,
  placeholder,
  onSuggestionSelected,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (inputValue.length < 2) {
      setSuggestions([]);
      return;
    }

    const loadSuggestions = async () => {
      const newSuggestions = await serviceFetchMedicineSuggestions(inputValue);
      setSuggestions(newSuggestions);
    };

    loadSuggestions();
  }, [inputValue]);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option" && newValue) {
      setInputValue(newValue.label); // Ensure inputValue is updated with the selected label
      onChange({ target: { name, value: newValue.value } });
      onSuggestionSelected(newValue);
    } else if (actionMeta.action === "create-option" && newValue) {
      console.log("Creating a new option:", newValue);
    } else if (actionMeta.action === "clear") {
      setInputValue(""); // Reset the internal input value
      onChange({ target: { name, value: "" } });
      onSuggestionSelected(null);
    }
  };

  const handleInputChange = (newInputValue, actionMeta) => {
    // Update inputValue only for input-change, not for menu-close
    if (actionMeta.action === "input-change") {
      setInputValue(newInputValue);
    }
  };

  // Determine if the clear button should be shown
  const isClearable = !!inputValue || !!value.label;

  return (
    <CreatableSelect
      isClearable={isClearable} // Control the visibility of the clear button dynamically
      isSearchable
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={suggestions}
      placeholder={placeholder}
      value={value} // This assumes value is managed correctly as an object elsewhere
      className=" "
      classNamePrefix="border-gray-200"
    />
  );
};

export default MedicineAutocomplete;
